const DIALOG_STACK_KEY = "__dialogStackTop"

function readTop(state: unknown): number {
  const s = state as Record<string, unknown> | null | undefined
  return s && typeof s[DIALOG_STACK_KEY] === "number" ? (s[DIALOG_STACK_KEY] as number) : 0
}

export function useDialog(initialState = false) {

  let state = $state(initialState)
  let myIndex: number | null = null
  let closing = false
  let closingTo = 0

  $effect(() => {
    if (!state) return

    const currentTop: number = readTop(window.history.state)
    const nextTop = currentTop + 1
    myIndex = nextTop

    const nextState = { ...(window.history.state ?? {}), [DIALOG_STACK_KEY]: nextTop }
    window.history.pushState(nextState, "", window.location.href)

    function handlePopState(event: PopStateEvent) {

      const newTop: number = readTop(event.state)

      if (closing) {
        closing = false
        if (newTop === closingTo) return
      }

      if (state && myIndex != null && myIndex > newTop) {
        myIndex = null
        state = false
      }
    }

    window.addEventListener("popstate", handlePopState)
    return () => {
      window.removeEventListener("popstate", handlePopState)
    }
  })

  function setOpen(newOpen?: boolean) {
    if (newOpen != null && newOpen === state) return
    if (newOpen) {
      state = true
      return
    }
    // Close synchronously: state flips immediately so enabled: dialog.state
    // queries disable at once instead of refetching on the next open.
    state = false
    if (myIndex != null && readTop(window.history.state) === myIndex) {
      closing = true
      closingTo = myIndex - 1
      window.history.back()
    } else {
      // not top (another dialog opened above) — close locally, don't pop
      closing = false
      closingTo = 0
    }
    myIndex = null
  }

  return {
    get state() {
      return state
    },
    setOpen,
  }
}
